import {
  Avatar,
  Box,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../app/features/authSlice";
import { doSignOut } from "../../components/Firebase/auth";
import { useAuth } from "../contexts/authContext";
import { RootState } from "../../app/store";

function stringAvatar(name: string) {
  return name?.split(" ")?.[0][0];
}

const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const { currentUser } = useAuth();
  const [open, setOpen] = useState<boolean>(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  };

  // Overload signatures
  function handleClose(event: MouseEvent | TouchEvent): void;
  function handleClose(event: React.MouseEvent): void;
  // Implementation of overloaded function
  function handleClose(
    event: MouseEvent | TouchEvent | React.MouseEvent
  ): void {
    const target = (event as MouseEvent | TouchEvent).target as Node | null;
    if (anchorRef.current && target && anchorRef.current.contains(target)) {
      return;
    }
    setOpen(false);
  }

  const handleLogOut = async (event: React.MouseEvent) => {
    try {
      if (currentUser?.uid) {
        await doSignOut(currentUser.uid);
      } else {
        await doSignOut();
      }
      dispatch(logOut());
    } catch (error) {
      console.error("Logout error:", error);
      dispatch(logOut());
    }
    handleClose(event);
  };
  return (
    <Box>
      <Avatar
        sx={{
          bgcolor: "primary.main",
          cursor: "pointer",
          width: 32,
          height: 32,
        }}
        onClick={handleToggle}
        ref={anchorRef}
      >
        <Typography variant="body1"></Typography>
        {stringAvatar(user ?? "")}
      </Avatar>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  // autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default Profile;
